import { ingredientDisplayQty } from './ingredientQuantity.js'

/**
 * One plain-text line for a grocery item (qty + name), matching Shop list display.
 * @param {object} item
 * @returns {string}
 */
export function formatShoppingListLine(item) {
  if (!item || typeof item !== 'object') return ''
  const name = String(item.item || item.name || item.item_name || '').trim()
  if (!name) return ''
  const qty = ingredientDisplayQty(item)
  return qty ? `${qty} ${name}` : name
}

/**
 * Format shopping-list items as newline-separated plain text for copy/paste.
 * Defaults to still-to-buy (incomplete) items; if none remain, includes all.
 *
 * @param {object[]} items
 * @param {{ includeCompleted?: boolean }} [options]
 * @returns {string}
 */
export function formatShoppingListPlainText(items, { includeCompleted = false } = {}) {
  const source = Array.isArray(items) ? items : []
  let list = includeCompleted ? source : source.filter((item) => !item.completed)
  if (!includeCompleted && list.length === 0 && source.length > 0) {
    list = source
  }
  return list.map(formatShoppingListLine).filter(Boolean).join('\n')
}
